import { store } from "../store";
import Controller from "./Controller";
import apiClientToken from "../plugins/axiosToken";

export default class UsuariosUbicaciones {
  getUbicaciones(context) {
    var t = context;
    var controller = new Controller();
    return new Promise(function (resolve, reject) {
      apiClientToken
        .get(
          store.getters.getUrlServicios + "WCFUsuariosUbicaciones.svc/RestService/GetUbicaciones"
        )
        .then(function (response) {
          resolve(controller.getData(context, response));
        })
        .catch(function (error) {
          t.$toast.add({
            severity: "error",
            summary: "ERROR",
            detail: "Error al obtener los estados",
            life: 3000,
          });
          console.log(error);
          reject(error);
        });
    });
  }

  Add(context, param) {
    var t = context;
    var controller = new Controller();
    return new Promise(function (resolve, reject) {
      apiClientToken
        .post(
          store.getters.getUrlServicios + "WCFUsuariosUbicaciones.svc/RestService/Add",
          param
        )
        .then(function (response) {
          resolve(controller.getData(context, response));
        })
        .catch(function (error) {
          t.$toast.add({
            severity: "error",
            summary: "ERROR",
            detail: "Error al crear el estado",
            life: 3000,
          });
          console.log(error);
          reject(error);
        });
    });
  }

  getAsignaciones(context){
    var t = context     
    var controller = new Controller();
    return new Promise(function(resolve,reject){            
        apiClientToken.get(store.getters.getUrlServicios + "WCFUsuariosUbicaciones.svc/RestService/GetAll")
        .then(function(response){
            resolve(controller.getData(context,response));
        })
        .catch(function(error){
          t.$toast.add({
              severity:"error",
              summary:"ERROR",
              detail:"Error al obtener datos del servidor",
              life: 3000
          });
          console.log(error);
          reject(error);
        })
    })
  }

  eliminarDelegaciones(contect, param){
    var t = contect;
    var controller = new Controller();

    console.log("Eliminar delegaciones", param);

    return new Promise(function(resolve,reject){
        apiClientToken.post(store.getters.getUrlServicios + "WCFUsuariosUbicaciones.svc/RestService/DeleteUbicaciones", param)
        .then(function(response){
            resolve(controller.getData(contect,response));
        })
        .catch(function(error){
          t.$toast.add({
              severity:"error",
              summary:"ERROR",
              detail:"Error al eliminar el estado",
              life: 3000
          });
          console.log(error);
          reject(error);
        })
    })
  }

}